import { Api } from "@vzbl/integrations";
import { SearchContext } from "../useSearchContext";
import { MiniCard } from "./MiniCard";

export const EntityCard = (
  props: Api.EntityItem & { context?: Pick<SearchContext, "entity"> }
) => {
  return (
    <div className="open-entity">
      <MiniCard
        context={props.context}
        style={{ padding: 0 }}
        data={{ attributes: props }}
      />
    </div>
  );
};
